import * as React from "react";
import { Link } from "gatsby";

import Logo from "../images/logo-vault-staking-footer.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="seperator"></div>

      <div className="container">
        <div className="footer--socials">
          <a
            href="https://twitter.com/vaultstaking"
            className="footer--social footer--social--twitter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M48 9.1001C46.2 9.9001 44.3 10.4001 42.3 10.7001C44.3 9.5001 45.9 7.6001 46.6 5.3001C44.7 6.4001 42.6 7.2001 40.3 7.7001C38.5 5.8001 35.9 4.6001 33.1 4.6001C27.7 4.6001 23.3 9.0001 23.3 14.4001C23.3 15.2001 23.4 15.9001 23.6 16.6001C15.5 16.2001 8.2 12.3001 3.3 6.3001C2.5 7.8001 2 9.4001 2 11.2001C2 14.6001 3.7 17.6001 6.4 19.4001C4.8 19.3001 3.3 18.9001 1.9 18.2001V18.3001C1.9 23.1001 5.3 27.1001 9.8 28.0001C9 28.2001 8.1 28.3001 7.2 28.3001C6.6 28.3001 5.9 28.2001 5.3 28.1001C6.6 32.0001 10.2 34.9001 14.5 34.9001C11.1 37.5001 6.9 39.1001 2.3 39.1001C1.5 39.1001 0.7 39.1001 0 39.0001C4.4 41.8001 9.5 43.4001 15.1 43.4001C33.2 43.4001 43.1 28.4001 43.1 15.4001C43.1 15.0001 43.1 14.5001 43.1 14.1001C45 12.8001 46.7 11.1001 48 9.1001Z"
                fill="white"
              />
            </svg>
            Twitter
          </a>
          <a
            href="https://t.me/vaultstaking"
            className="footer--social footer--social--telegram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M46.9094 5.84298C46.8727 5.673 46.7913 5.51587 46.6737 5.38775C46.5562 5.25962 46.4066 5.16513 46.2404 5.11398C45.6365 4.99379 45.0114 5.038 44.4304 5.24198C44.4304 5.24198 4.29237 20 1.82337 21.333C1.25137 21.642 1.16137 21.879 1.07937 22.115C0.67937 23.257 1.92137 23.761 1.92137 23.761L12.3094 27.146L17.2684 40.627C17.2684 40.627 17.8124 41.934 18.5764 41.934C18.9024 41.934 19.6404 41.591 20.6954 40.534C22.9344 38.295 25.0834 36.439 26.1564 35.534C29.7284 38.001 33.5724 40.728 35.2314 42.155C35.5091 42.4241 35.8382 42.6346 36.1989 42.7739C36.5597 42.9132 36.9448 42.9786 37.3314 42.966C38.9064 42.907 39.3454 41.178 39.3454 41.178C39.3454 41.178 46.6904 11.617 46.9354 7.65698C46.9594 7.26898 46.9924 7.02198 46.9964 6.75698C47.0095 6.44977 46.9802 6.14221 46.9094 5.84298ZM14.0724 26.333C19.2624 23.058 36.7334 12.055 37.8464 11.646C38.0464 11.588 38.1854 11.654 38.1464 11.788C37.6524 13.523 19.1224 30 19.0544 30.055C19.0114 30.0951 18.9774 30.1437 18.9545 30.1978C18.9316 30.2519 18.9203 30.3102 18.9214 30.369L18.2004 37.774L14.0724 26.333Z"
                fill="white"
              />
            </svg>
            Telegram
          </a>
          <a
            href="https://discord.gg/R89tMFNa54"
            className="footer--social footer--social--discord"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.8377 20.3001C19.1976 20.3539 18.6011 20.6462 18.1663 21.119C17.7315 21.5919 17.4902 22.2108 17.4902 22.8531C17.4902 23.4955 17.7315 24.1144 18.1663 24.5872C18.6011 25.0601 19.1976 25.3523 19.8377 25.4061C20.4778 25.3523 21.0743 25.0601 21.5091 24.5872C21.9438 24.1144 22.1851 23.4955 22.1851 22.8531C22.1851 22.2108 21.9438 21.5919 21.5091 21.119C21.0743 20.6462 20.4778 20.3539 19.8377 20.3001ZM28.2377 20.3001C27.7236 20.2566 27.2083 20.3694 26.7594 20.6236C26.3104 20.8778 25.9487 21.2616 25.7215 21.7248C25.4943 22.188 25.4122 22.709 25.486 23.2196C25.5599 23.7302 25.7861 24.2066 26.1352 24.5865C26.4843 24.9664 26.9399 25.2321 27.4425 25.3487C27.9451 25.4653 28.4711 25.4275 28.9519 25.2402C29.4326 25.0529 29.8455 24.7248 30.1367 24.2989C30.4279 23.873 30.5837 23.3691 30.5837 22.8531C30.5975 22.531 30.5476 22.2093 30.4368 21.9065C30.326 21.6037 30.1566 21.3258 29.9382 21.0886C29.7198 20.8514 29.4567 20.6597 29.164 20.5244C28.8713 20.3891 28.5549 20.3129 28.2327 20.3001H28.2377Z"
                fill="white"
              />
              <path
                d="M39.4105 1H8.59046C7.32376 1.06836 6.13415 1.62989 5.27628 2.56439C4.41841 3.49888 3.96046 4.73208 4.00046 6V37C3.98813 37.6053 4.09856 38.2069 4.32509 38.7683C4.55162 39.3298 4.88956 39.8395 5.31851 40.2668C5.74746 40.6941 6.25853 41.03 6.82088 41.2543C7.38323 41.4786 7.9852 41.5867 8.59046 41.572H34.6725L33.4535 37.317L36.4005 40.054L39.1805 42.63L44.0005 47V6C44.0405 4.73208 43.5825 3.49888 42.7246 2.56439C41.8668 1.62989 40.6772 1.06836 39.4105 1ZM30.5325 31.038C30.5325 31.038 29.7045 30.049 29.0145 29.175C30.6816 28.7824 32.1562 27.8129 33.1775 26.438C32.3501 26.9905 31.4628 27.4474 30.5325 27.8C29.4625 28.2567 28.3434 28.5886 27.1975 28.789C25.2276 29.1517 23.2074 29.1439 21.2405 28.766C20.0857 28.5401 18.954 28.209 17.8595 27.777C16.9372 27.4248 16.0576 26.9696 15.2375 26.42C16.2217 27.7662 17.6454 28.7262 19.2625 29.134C18.5725 30.008 17.7215 31.043 17.7215 31.043C12.6385 30.882 10.7065 27.543 10.7065 27.543C10.7811 22.8802 11.9136 18.2953 14.0185 14.134C15.8708 12.6792 18.129 11.8354 20.4815 11.719L20.7115 11.995C18.4983 12.5427 16.433 13.5715 14.6625 15.008C14.6625 15.008 15.1685 14.732 16.0195 14.341C17.6727 13.5863 19.4347 13.0973 21.2405 12.892C21.3692 12.8654 21.5 12.85 21.6315 12.846C23.1727 12.6452 24.7325 12.6297 26.2775 12.8C28.707 13.0772 31.0588 13.8269 33.2005 15.007C31.5198 13.6389 29.5677 12.6433 27.4735 12.086L27.7955 11.718C30.1479 11.8344 32.4061 12.6782 34.2585 14.133C36.3633 18.2943 37.4958 22.8792 37.5705 27.542C37.5705 27.542 35.6155 30.877 30.5325 31.038Z"
                fill="white"
              />
            </svg>
            Discord
          </a>
          <a
            href="mailto:hello@vaultstaking.com"
            className="footer--social footer--social--mail"
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42 5H6C5.34339 5 4.69321 5.12933 4.08658 5.3806C3.47995 5.63188 2.92876 6.00017 2.46447 6.46447C1.52678 7.40215 1 8.67392 1 10V14C0.999967 14.1797 1.04833 14.356 1.14001 14.5105C1.23169 14.665 1.3633 14.7919 1.521 14.878L23.521 26.878C23.6679 26.9582 23.8326 27.0002 24 27.0002C24.1674 27.0002 24.3321 26.9582 24.479 26.878L46.479 14.878C46.6367 14.7919 46.7683 14.665 46.86 14.5105C46.9517 14.356 47 14.1797 47 14V10C47 8.67392 46.4732 7.40215 45.5355 6.46447C44.5979 5.52678 43.3261 5 42 5Z"
                fill="white"
              />
              <path
                d="M25.437 28.634C24.9967 28.8738 24.5034 28.9995 24.002 28.9995C23.5006 28.9995 23.0073 28.8738 22.567 28.634L1.023 16.885L1 16.9V38C1 39.3261 1.52678 40.5979 2.46447 41.5355C3.40215 42.4732 4.67392 43 6 43H42C43.3261 43 44.5979 42.4732 45.5355 41.5355C46.4732 40.5979 47 39.3261 47 38V16.9L46.977 16.886L25.437 28.634Z"
                fill="white"
              />
            </svg>
            Mail
          </a>
        </div>
      </div>
      <div className="seperator"></div>
      <div className="container">
        <div className="footer--copyrights">
          <div className="left-side">
            <Link to="/" className="footer-logo">
              <img src={Logo} alt="logo vault staking" />
            </Link>
            <nav>
              <ul>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="right-side">
            <div className="designed">
              Designed by
              <a
                href="https://flairdigital.co/"
                rel="noreferrer"
                target="_blank"
              >
                Flair Digital
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
